import type { ProjectCardProps } from '../../components/ProjectCard';

export type Project = ProjectCardProps & { id: string };

export const PROJECTS: Project[] = [
  {
    id: 'arcade-ui',
    title: 'Arcade UI',
    description:
      '16-bit retro React component library with cabinet controls — ArcadeButton, PixelInput, RetroBadge, and InventoryChip. Built with CSS Modules and Storybook.',
    tags: ['React', 'TypeScript', 'Storybook', 'CSS Modules'],
    repoUrl: 'https://github.com/wolftrax5/arcade-ui',
    liveUrl: 'https://rt.wolftrax.me',
    previewAlt: 'Arcade UI',
    previewSrc:
      'https://og.wolftrax.me/api/og-3d?shape=cone&color=f43f5e&light=0.6&metalness=0.85&width=800&height=500&bg=1e1f20',
  },
  {
    id: 'og-3d-generator',
    title: 'OG 3D Generator',
    description:
      'Draws a shaded primitive as SVG, rasterizes it to PNG with next/og, and serves it with immutable caching. No image files, no GPU, no headless browser — the whole image is generated from the query string.',
    tags: ['Next.js', 'Satori', 'SVG', 'TypeScript'],
    repoUrl: 'https://github.com/wolftrax5/og-3d-generator',
    liveUrl: 'https://og.wolftrax.me',
    previewSrc:
      'https://og.wolftrax.me/api/og-3d?shape=torusknot&color=67e813&metalness=1&roughness=0.15&width=800&height=500&bg=1e1f20',
    previewAlt: 'Shaded torus knot generated by OG 3D Generator',
  },
  {
    id: 'chromasync',
    title: 'ChromaSync',
    description:
      'Real-time collaborative whiteboard with shared strokes, live cursors, and a pressure-sensitive pen. Built with Liveblocks CRDTs and perfect-freehand.',
    tags: ['Next.js', 'Liveblocks', 'perfect-freehand', 'TypeScript'],
    repoUrl: 'https://github.com/wolftrax5/ChromaSync',
    liveUrl: 'https://cs.wolftrax.me',
  },
];
